import React, { createContext, useContext, useState } from "react";

import Snackbar, { SnackbarOrigin } from "@mui/material/Snackbar";
import MuiAlert, { AlertProps } from "@mui/material/Alert";
import { JSX } from "react/jsx-runtime";

const Alert = React.forwardRef<HTMLDivElement, AlertProps>(function Alert(
  props,
  ref,
) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});


export interface State extends SnackbarOrigin {
  duration: number;
}

interface ParamsAlerts {
  tipoAlerta: "error" | "warning" | "info" | "success";
  show: boolean;
  menssage: string;
  handleClose():void;
}

export default function Alerts(params: ParamsAlerts) {
  const { tipoAlerta, show, menssage, handleClose } = params;
  const [state, setState] = React.useState<State>({
    vertical: "bottom",
    horizontal: "right",
    duration: 5000
  });
  const { vertical, horizontal, duration } = state;


  return (
    <Snackbar
      id={'snackbar-alert'}
      open={show}
      autoHideDuration={duration}
      onClose={handleClose}
      anchorOrigin={{ vertical, horizontal }}
      disableWindowBlurListener={true}
    >
      <Alert onClose={handleClose} severity={tipoAlerta} color={tipoAlerta}>
        <div>{menssage}</div>
      </Alert>
    </Snackbar>
  );
}

interface AlertaProviderProps {
  alertaState:{show:boolean,menssage:string,tipoAlerta: "error" | "warning" | "info" | "success"}
  handleClose:()=>any,
  handleShowAlerta:(msg:string,tipoAlerta: "error" | "warning" | "info" | "success")=>any
  AlertaView:()=>JSX.Element
}

function alertaProvider():AlertaProviderProps{
  const [alertaState, setAlertaState] = useState<{show:boolean,menssage:string,tipoAlerta: "error" | "warning" | "info" | "success"}>({
    show:false,
    menssage:"",
    tipoAlerta:"info"
  })

  const handleClose = () => {
    setAlertaState(state=>({...state,show:false,menssage:""}));
  }

  const handleShowAlerta = (msg:string,tipoAlerta: "error" | "warning" | "info" | "success") => {
    setAlertaState(state=>({...state,show:true,menssage:msg,tipoAlerta:tipoAlerta}));
  }


    const AlertaView = () => {
        return <Alerts handleClose={handleClose} menssage={alertaState.menssage} show={alertaState.show} tipoAlerta={alertaState.tipoAlerta} />
    }  
  
  return {
    alertaState,
    handleClose,
    handleShowAlerta,
    AlertaView
  }
}

const alertaContexto = createContext({} as AlertaProviderProps)

const useAlerta = () => {
  return useContext(alertaContexto);
}

const AlertaProvider = ({ children }: any) => {
  const provider = alertaProvider()
  return (
    <alertaContexto.Provider value={provider}>
      {children}
    </alertaContexto.Provider>
  )
}

export {
  AlertaProvider,
  useAlerta
}


